// @ts-nocheck
import { IndustryHighlight } from '@core/config/industryHighlights';

import GraduationCap from '../Icons/GraduationCap';
import PiggyBank from '../Icons/PiggyBank';
import TrendingUp from '../Icons/TrendingUp';
import styles from './CareerOutlook.module.css';

// Import your preferred icon library

const iconMap = {
  'piggy-bank': PiggyBank,
  'dine-and-dash': TrendingUp, // This seems like it might be a custom icon, replace with appropriate one
  'grad-cap-toss': GraduationCap,
  'arrow-to-clouds': TrendingUp,
};

type CareerOutlookProps = {
  industryData: IndustryHighlight; // Replace 'any' with the actual type if available
};

const CareerOutlook = ({ industryData }: CareerOutlookProps) => {
  if (!industryData || !industryData.careerOutlook || industryData.careerOutlook.length === 0) {
    return null;
  }

  const renderIcon = (iconName) => {
    if (!iconName) return null;

    const IconComponent = iconMap[iconName];

    if (IconComponent) {
      return <IconComponent className={styles.icon} aria-hidden="true" />;
    }

    // Fallback for unknown icons
    return null;
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Career Outlook</h2>

      <div className={styles.outlookList}>
        {industryData.careerOutlook.map((outlook, index) => (
          <div key={index} className={styles.outlookItem}>
            <div className={styles.iconWrapper}>
              <div className={styles.iconWrapper}>{renderIcon(outlook.icon)}</div>
            </div>
            <div>
              <div className={styles.outlookTitle}>{outlook.title}</div>
              <div className={styles.outlookDescription}>{outlook.description}</div>
            </div>
          </div>
        ))}
      </div>

      {industryData.careerOutlookLinks && (
        <div className={styles.sourceWrapper}>
          <span className={styles.sourceLabel}>{industryData.careerOutlookLinks.label} </span>
          {industryData.careerOutlookLinks.links.map((link, index) => (
            <span key={index}>
              <a href={link.link} className={styles.sourceLink} target="_blank" rel="noopener noreferrer">
                {link.linkText}
              </a>
              {index < industryData.careerOutlookLinks.links.length - 1 && (
                <span className={styles.linkSeparator}>, </span>
              )}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default CareerOutlook;
